// Mock data for İlka Mühendislik clone (frontend-only teaser)

export const company = {
  name: "İLKA MÜHENDİSLİK",
  tagline: "Çelik Konstrüksiyon",
  phone: "0532 233 00 19",
  phoneHref: "tel:+905322330019",
  email: "ilkercoka@ilkamuhendislik.com.tr",
  location: "KARTEPE / KOCAELİ",
  hoursWeek: "Haftaiçi: 08.00 - 18.00",
  hoursSunday: "Pazar KAPALI",
  logo: "/images/misc/logo.png",
  about:
    "Taahhütlerimiz altında bulunan Çelik Konstrüksiyon, Saha Tankları, Basınçlı Tanklar, Çelik Köprü ve Viyadükler, Depolama Siloları ve Ekipman İmalatlarımızı Dünya standartlarında ve %100 izlenebilirlik kalite politikamız ile gerçekleştirmekteyiz."
};

export const navItems = [
  { label: "ANASAYFA", to: "/" },
  { label: "KURUMSAL", to: "/kurumsal" },
  { label: "UYGULAMALAR", to: "/uygulamalar" },
  { label: "REFERANSLARIMIZ", to: "/referanslar" },
  { label: "BİZDEN HABERLER", to: "/haberler" },
  { label: "İLETİŞİM", to: "/iletisim" }
];

export const slides = [
  {
    image: "/images/slider/slider.jpg",
    eyebrow: "Çelik İmalat ve Montajında",
    title: "Öncü Firmayız",
    text: "Yılların vermiş olduğu tecrübeyle hem üretim hem montaj aşamasında işimizin başındayız."
  },
  {
    image: "/images/slider/slider1.jpg",
    eyebrow: "20 Yıllık Tecrübenin",
    title: "Yorumlandığı Yer \"İLKA\"",
    text: "Kalite anlayışı ve güven olgusu ile çeliğin hayat bulduğu yer."
  },
  {
    image: "/images/slider/slider2.jpg",
    eyebrow: "Çelik Barındıran Her Projede",
    title: "Var Olmanın Hedefi \"İLKA\"",
    text: "Var olmayı hedef politikası haline getirdiğimiz yer."
  },
  {
    image: "/images/slider/slider3.jpg",
    eyebrow: "Kalite Anlayışı ve Güven Olgusu ile",
    title: "Çeliğin Hayat Bulduğu Yer",
    text: "Standartlardan ödün vermeden üretiyoruz."
  },
  {
    image: "/images/slider/slider4.jpg",
    eyebrow: "Zaman Kavramının",
    title: "Anlam Kazandığı Yer \"İLKA\"",
    text: "Zamanında teslimat, taahhütlerimizin özüdür."
  },
  {
    image: "/images/slider/slider5.jpg",
    eyebrow: "Emeğin Karşılığı",
    title: "Olan Yer \"İLKA\"",
    text: "Emeğe değer veren üretim anlayışı."
  }
];

export const stats = [
  { value: "20+", label: "Yıllık Tecrübe" },
  { value: "600", label: "Ton / Ay Kapasite" },
  { value: "1000", label: "Ton Hedef Kapasite" },
  { value: "%100", label: "İzlenebilirlik" }
];

export const homeIntro = {
  eyebrow: "ÇELİK KONSTRÜKSİYON",
  title: "Çeliğe Hakettiği Değeri Veriyoruz",
  paragraphs: [
    "EN 1090-2, AWS ve TSE standartlarına uygun ve zamanında teslimatlarımızla tercih sebebi olmaya devam etmekteyiz.",
    "Uzun yılların tecrübesini İLKA'da hayata geçirerek şu anki 400-600 Ton aylık kapasitemizi kısa zamanda 1000 Ton'a çıkartmak için çalışmaktayız.",
    "Otomatik kumlama ve boyama, plazma ve lazer kesim ve otomatik tozaltı kaynak ünitelerimiz ile çelikte kalite hedeflerimizi sürekli yüksek tutmaktayız.",
    "Proje ve statik çözümlerde optimum seviyeler ile tasarım yapmakta olup, işlenebilirlik açısından en uygun yöntemleri de göz önüne alabilmekteyiz."
  ]
};

export const bridgeSection = {
  eyebrow: "ÇELİK KÖPRÜ VE VİYADÜKLER'DE",
  title: "Tercih Sebebiyiz",
  image: "/images/misc/montaj.jpg",
  paragraphs: [
    "Çelik Köprü ve Viyadüklerde AWS, EN ve TSE standartlarına göre imalat yapmaktayız.",
    "Özlü tel ile gazaltı ve tozaltı otomatik kaynak yöntemleri ile yapma kiriş ve kolonlarımız %100 NDT kontrollerinden geçirilerek pozitif sonuç almaktadır.",
    "3 eksenli form verilerek köprü kiriş ve/veya ana taşıyıcı omurga imalatı yapabilme kabiliyetine sahibiz."
  ],
  bullets: [
    "Geniş Açıklıklı Otoyol Çelik Viyadükleri",
    "Çelik Yaya Geçitleri",
    "Çelik Üst Geçitler",
    "Geçiş Köprüleri"
  ]
};

export const applications = [
  {
    slug: "celik-konstruksiyon",
    title: "Çelik Konstrüksiyon",
    image: "/images/apps/celik-konstruksiyon.jpg",
    excerpt: "EN 1090-2, AWS ve TSE standartlarına uygun çelik yapı imalat ve montajı.",
    body: [
      "İmalatlarımızda çeliğe hakettiği değeri verdiğimizi düşünmekteyiz. EN 1090-2, AWS ve TSE standartlarına uygun ve zamanında teslimatlarımızla tercih sebebi olmaya devam etmekteyiz.",
      "Otomatik kumlama ve boyama, plazma ve lazer kesim ve otomatik tozaltı kaynak üniteleri ile endüstriyel tesis, fabrika ve depo çelik konstrüksiyonlarını anahtar teslim gerçekleştiriyoruz."
    ]
  },
  {
    slug: "basincli-kaplar",
    title: "Basınçlı Kaplar",
    image: "/images/apps/basincli-kaplar.jpg",
    excerpt: "Uluslararası standartlarda basınçlı kap tasarımı ve imalatı.",
    body: [
      "Basınçlı kap imalatlarımızı ilgili tasarım kodları ve kalite standartları doğrultusunda gerçekleştiriyoruz.",
      "Malzeme seçiminden kaynak prosedürlerine, NDT kontrollerinden hidrostatik testlere kadar tüm süreçleri %100 izlenebilirlik ile yönetiyoruz."
    ]
  },
  {
    slug: "saha-tanklari",
    title: "Saha Tankları",
    image: "/images/apps/saha-tanklari.jpg",
    excerpt: "Depolama ve proses amaçlı saha tanklarının imalat ve montajı.",
    body: [
      "Saha tanklarının imalat ve montajını sahada ve atölyede uluslararası standartlara uygun olarak gerçekleştiriyoruz.",
      "Otomatik kaynak yöntemleri ve kapsamlı NDT kontrolleri ile uzun ömürlü ve güvenli depolama çözümleri sunuyoruz."
    ]
  },
  {
    slug: "celik-kopru-ve-viyadukler",
    title: "Çelik Köprü ve Viyadükler",
    image: "/images/apps/celik-kopru.jpg",
    excerpt: "AWS, EN ve TSE standartlarında köprü ve viyadük imalatı.",
    body: [
      "Çelik köprü ve viyadüklerde AWS, EN ve TSE standartlarına göre imalat yapmaktayız. Özlü tel ile gazaltı ve tozaltı otomatik kaynak yöntemleri kullanıyoruz.",
      "Yapma kiriş ve kolonlarımız %100 NDT kontrollerinden geçmektedir. 3 eksenli form verilerek köprü kiriş ve ana taşıyıcı omurga imalatı yapabilmekteyiz."
    ]
  },
  {
    slug: "ekipman-imalatlari",
    title: "Ekipman İmalatları",
    image: "/images/apps/ekipman-imalatlari.jpg",
    excerpt: "Endüstriyel proses ekipmanlarının özel imalatı.",
    body: [
      "Endüstriyel tesislerin ihtiyaç duyduğu özel ekipmanları proje bazlı olarak tasarlıyor ve imal ediyoruz.",
      "Mühendislik hesaplarından son montaja kadar tüm süreçleri titizlikle yönetiyoruz."
    ]
  },
  {
    slug: "bunker-ve-mikserler",
    title: "Bunker ve Mikserler",
    image: "/images/apps/bunker-mikserler.jpg",
    excerpt: "Bunker, silo besleme ve mikser sistemleri imalatı.",
    body: [
      "Bunker ve mikser sistemlerini proses gereksinimlerine göre tasarlayıp imal ediyoruz.",
      "Aşınmaya dayanıklı malzeme seçenekleri ile uzun ömürlü çözümler sunuyoruz."
    ]
  },
  {
    slug: "silolar",
    title: "Silolar",
    image: "/images/apps/silolar.jpg",
    excerpt: "Depolama siloları tasarımı, imalatı ve montajı.",
    body: [
      "Depolama silolarını mühendislik hesaplarına dayalı olarak imal ve monte ediyoruz.",
      "Farklı kapasite ve malzeme türleri için özel çözümler geliştiriyoruz."
    ]
  },
  {
    slug: "gaz-duct",
    title: "Gaz Duct",
    image: "/images/apps/gaz-duct.jpg",
    excerpt: "Enerji santralleri için duman kanalı (gaz duct) imalatı.",
    body: [
      "Enerji santralleri ve endüstriyel tesisler için duman kanalı (gaz duct) imalat ve montajını gerçekleştiriyoruz.",
      "Yüksek sıcaklık ve basınç koşullarına uygun malzeme ve kaynak çözümleri uyguluyoruz."
    ]
  },
  {
    slug: "liman-vincleri",
    title: "Liman Vinçleri",
    image: "/images/apps/liman-vincleri.jpg",
    excerpt: "Liman vinçleri için çelik konstrüksiyon çözümleri.",
    body: [
      "Liman vinçlerinin taşıyıcı çelik konstrüksiyonlarını imal ve monte ediyoruz.",
      "Ağır yük koşullarına uygun mühendislik ve kalite standartları ile çalışıyoruz."
    ]
  },
  {
    slug: "plazma-kesim-ve-otomatik-kumlama-islemleri",
    title: "Plazma Kesim ve Otomatik Kumlama İşlemleri",
    image: "/images/apps/plazma-kesim.jpg",
    excerpt: "Plazma/lazer kesim ve otomatik kumlama-boyama hizmetleri.",
    body: [
      "Plazma ve lazer kesim ünitelerimiz ile hassas kesim işlemleri gerçekleştiriyoruz.",
      "Otomatik kumlama ve boyama üniteleri ile yüzey hazırlığı ve korozyon koruması sağlıyoruz."
    ]
  },
  {
    slug: "danismanlik-ve-muhendislik-hizmetleri",
    title: "Danışmanlık ve Mühendislik Hizmetleri",
    image: "/images/apps/danismanlik.jpg",
    excerpt: "Proje, statik çözüm ve mühendislik danışmanlığı.",
    body: [
      "Proje ve statik çözümlerde optimum seviyeler ile tasarım yapmakta olup, işlenebilirlik açısından en uygun yöntemleri de göz önüne alabilmekteyiz.",
      "Fikir aşamasından uygulamaya kadar mühendislik danışmanlığı sunuyoruz."
    ]
  },
  {
    slug: "boru-hatlari",
    title: "Boru Hatları",
    image: "/images/apps/boru-hatlari.jpg",
    excerpt: "Proses ve tesis boru hatları imalat ve montajı.",
    body: [
      "Endüstriyel tesislerin proses boru hatlarını imal ve monte ediyoruz.",
      "Kaynak prosedürleri ve NDT kontrolleri ile güvenli ve sızdırmaz hatlar sunuyoruz."
    ]
  },
  {
    slug: "paslanmaz-ekipmanlar",
    title: "Paslanmaz Ekipmanlar",
    image: "/images/apps/paslanmaz-ekipmanlar.jpg",
    excerpt: "Gıda ve proses sektörü için paslanmaz çelik imalatlar.",
    body: [
      "Gıda, kimya ve proses sektörleri için paslanmaz çelik ekipman imalatı yapıyoruz.",
      "Hijyenik kaynak ve yüzey işlemleri ile standartlara uygun ürünler sunuyoruz."
    ]
  }
];

export const news = [
  {
    slug: "serban-as-turkcell-gunes-panelleri",
    title: "Serban A.Ş - Türkcell Güneş Panelleri",
    date: "10.06.2017",
    image: "/images/news/serban.jpg",
    excerpt:
      "Serban A.Ş - Türkcell Binası Revizyonu şantiyemiz devam etmektedir. Güneş Panelleri ve Taşıyıcı Çelikleri Demontaj - Montajı, Makina Ana Taşıyıcı Çelik ve Platform imalatları sürmektedir.",
    body: [
      "Serban A.Ş - Türkcell Binası Revizyonu şantiyemiz devam etmektedir.",
      "Güneş Panelleri ve Taşıyıcı Çelikleri Demontaj - Montajı, Makina Ana Taşıyıcı Çelik ve Platform imalatlarımız titizlikle sürdürülmektedir.",
      "Projeye destek veren tüm çözüm ortaklarımıza teşekkür ederiz."
    ]
  },
  {
    slug: "cenal-elektrik-santrali-duman-kanali",
    title: "Cenal Elektrik Santrali Duman Kanalı Projemiz Başladı",
    date: "10.06.2017",
    image: "/images/news/cenal.jpg",
    excerpt:
      "Cenal Elektrik Santrali Duman Kanalı imalat ve montajı şantiyemiz başlamış bulunmaktadır. İLKA MÜHENDİSLİK adına başta Sn. Mehmet Tatar ve Sn. Onur Vakit olmak üzere tüm ekibimize başarılar dileriz.",
    body: [
      "Cenal Elektrik Santrali Duman Kanalı imalat ve montajı şantiyemiz başlamış bulunmaktadır.",
      "İLKA MÜHENDİSLİK adına başta Sn. Mehmet Tatar ve Sn. Onur Vakit olmak üzere tüm ekibimize başarılar dileriz.",
      "Proje sürecinde kalite ve iş güvenliği önceliğimiz olmaya devam edecektir."
    ]
  },
  {
    slug: "baku-towers-1000-ton",
    title: "Bakü Towers'ta 1000 Ton'a Ulaştık",
    date: "04.04.2017",
    image: "/images/news/baku.jpg",
    excerpt:
      "Modül Çelik bünyesinde imalatlarını üstlendiğimiz BAKÜ TOWERS Projesinde 1000 Ton'a ulaştık. Toplamda 1850 Ton olan projemizle ilgili bizlerden desteğini esirgemeyen herkese teşekkür ederiz.",
    body: [
      "Modül Çelik bünyesinde imalatlarını üstlendiğimiz BAKÜ TOWERS Projesinde 1000 Ton'a ulaştık.",
      "Toplamda 1850 Ton olan projemizle ilgili bizlerden desteğini esirgemeyen tüm çözüm ortaklarımıza ve ekibimize teşekkür ederiz.",
      "Hedeflerimize emin adımlarla ilerlemeye devam ediyoruz."
    ]
  }
];

export const references = Array.from({ length: 17 }, (_, i) => ({
  id: i + 1,
  image: `/images/refs/referans-${i + 1}.jpg`
}));
